import React from "react";

import classNames from "classnames";

import * as Color from "../Color";
import { Icon } from "../Icon";

import styles from "./styles.module.css";

interface HandleProps extends React.ButtonHTMLAttributes<HTMLButtonElement> {}

/** A handle component */
export const Handle = React.forwardRef<HTMLButtonElement, HandleProps>((props, ref) => {
  const { className, ...rest } = props;
  return (
    <button ref={ref} type="button" className={classNames(styles.Handle, "handle", className)} style={{ cursor: "grab" }} {...rest}>
      <Icon aria-hidden="true" name="grabber" size="regular" color={Color.LightGrey[500]} />
    </button>
  );
});
